import { useState, useCallback } from 'react';
import { ApiError } from '../api/api-keys/types';

export function useErrorHandling() {
  const [error, setError] = useState<ApiError | null>(null);

  const clearError = useCallback(() => setError(null), []);

  const handleError = useCallback((error: unknown) => {
    if (typeof error === 'string') {
      setError({ message: error });
    } else if (error instanceof Error) {
      setError({ message: error.message });
    } else if (typeof error === 'object' && error !== null) {
      setError(error as ApiError);
    } else {
      setError({ message: 'An unknown error occurred' });
    }
  }, []);

  return {
    error,
    setError,
    clearError,
    handleError,
  };
}
